export default "__VITE_PUBLIC_ASSET__69b5e3f4__"